import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

interface IExportButton {
  responsive: 'true' | 'false';
}

export const ExportButton = styled(Button)<IExportButton>(
  ({ theme, responsive }) => ({
    minWidth: '400px',
    border: `1px solid ${theme.palette.secondary.main}`,
    color: theme.palette.secondary.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
    '&:active': {
      backgroundColor: theme.palette.secondary.main,
    },
    '&:disabled': {
      color: theme.palette.secondary.main,
    },
    ...(responsive === 'true'
      ? {
          [theme.breakpoints.down('lg')]: {
            minWidth: '220px',
          },
        }
      : {
          maxWidth: '220px',
        }),
    span: {
      marginRight: '8px',
    },
  })
);
